"use strict";
// Cross-surface identity assembly — the ONE place that maps an account's
// identity onto PostHog super-properties and person properties, keyed by the
// SUPER_PROPS constants so a rename can't silently diverge a surface. Each
// surface maps its own /me-or-User source onto the primitive inputs below and
// calls these; the assembly (and the account-age math) is shared. Deps-free.
// See ADR-0016 and CONTEXT.md "Product analytics".
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountAgeDaysFromMs = accountAgeDaysFromMs;
exports.accountAgeDays = accountAgeDays;
exports.buildSuperProps = buildSuperProps;
exports.buildPersonProps = buildPersonProps;
const superProps_1 = require("./superProps");
// Plain literal (no numeric separator) — web's eslint-loader lints the
// symlinked shared/dist and its parser rejects `86_400_000`.
const MS_PER_DAY = 86400000;
// Whole days since account creation, or null when unknown/unparseable. The one
// definition all surfaces share — floor((now - created) / 86_400_000).
function accountAgeDaysFromMs(createdAtMs, nowMs) {
    if (createdAtMs == null || !Number.isFinite(createdAtMs))
        return null;
    // Clamp to non-negative: a future-dated / clock-skewed createdAt (client clock
    // behind the server-issued createdAt) must not register a negative
    // account_age_days super-prop/person prop and pollute cohorts.
    return Math.max(0, Math.floor((nowMs - createdAtMs) / MS_PER_DAY));
}
// Convenience for an ISO-string created_at (the shape /me returns to plugins).
function accountAgeDays(createdAtIso, nowMs = Date.now()) {
    if (!createdAtIso)
        return null;
    return accountAgeDaysFromMs(Date.parse(createdAtIso), nowMs);
}
// The cross-surface super-properties object (register()'d, attached to every
// event). Keyed via SUPER_PROPS so the drift test pins every surface.
function buildSuperProps(i) {
    return {
        // `||` not `??` — web's webpack-4 parser (which lints the symlinked shared
        // dist) can't parse nullish-coalescing; `extra` is object-or-undefined so
        // the two are equivalent here.
        ...(i.extra || {}),
        [superProps_1.SUPER_PROPS.SURFACE]: i.surface,
        [superProps_1.SUPER_PROPS.PLAN]: i.plan,
        [superProps_1.SUPER_PROPS.IS_TEAM_USER]: i.isTeamUser,
        [superProps_1.SUPER_PROPS.TEAM_ID]: i.teamId,
        [superProps_1.SUPER_PROPS.ACCOUNT_AGE_DAYS]: i.accountAgeDays,
        [superProps_1.SUPER_PROPS.IS_INTERNAL_ADMIN]: i.isInternalAdmin,
    };
}
// Person-level $set properties for identify(). Deliberately EXCLUDES
// surface/is_team_user/team_id — those are event-level super-props only; setting
// them as person properties pollutes the person and flip-flops across surfaces.
function buildPersonProps(i) {
    return {
        ...(i.email != null ? { email: i.email } : {}),
        plan: i.plan,
        is_rd_trial: i.isRdTrial,
        is_internal_admin: i.isInternalAdmin,
        account_age_days: i.accountAgeDays,
    };
}
